<ion-content>
  <div class="page-wrapper">

    <!-- One-time raw token reveal -->
    @if (justCreatedToken) {
    <div class="reveal-card">
      <div class="reveal-card__head">
        <ion-icon name="checkmark-circle-outline" color="success"></ion-icon>
        <strong>{{ 'tokens.reveal.created' | translate:{ name: justCreatedToken.name } }}</strong>
      </div>
      <p class="reveal-card__warn">
        {{ 'tokens.reveal.warn' | translate }}
      </p>
      <div class="reveal-card__token">
        <code>{{ justCreatedToken.rawToken }}</code>
        <ion-button size="small" fill="clear" (click)="copyToken(justCreatedToken.rawToken!)">
          <ion-icon name="copy-outline" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
      <ion-button size="small" fill="outline" (click)="dismissReveal()">{{ 'tokens.reveal.understood' | translate }}</ion-button>
    </div>
    }

    <div class="page-header">
      <h1>{{ 'tokens.title' | translate }}</h1>
      <ion-button (click)="openCreateForm()">
        <ion-icon name="add-outline" slot="start"></ion-icon>
        {{ 'tokens.newToken' | translate }}
      </ion-button>
    </div>

    <!-- Create form -->
    @if (showCreateForm) {
    <ion-card class="create-card">
      <ion-card-content>
        <ion-item>
          <ion-input [label]="'tokens.form.name' | translate" labelPlacement="stacked"
                     [placeholder]="'tokens.form.namePlaceholder' | translate"
                     [(ngModel)]="newName"></ion-input>
        </ion-item>
        <ion-item>
          <ion-input [label]="'tokens.form.expiresLabel' | translate" labelPlacement="stacked" type="number" min="1" max="365"
                     [(ngModel)]="newExpiresInDays"></ion-input>
        </ion-item>

        <div class="scope-picker">
          <div class="scope-picker__title">{{ 'tokens.form.scopeTitle' | translate }}</div>
          @for (feature of features; track feature) {
          <button type="button" class="scope-row" (click)="cycleLevel(feature)">
            <span class="scope-row__name">{{ feature }}</span>
            <ion-badge [color]="levelColor(draftScopes[feature])">{{ draftScopes[feature] }}</ion-badge>
          </button>
          }
        </div>

        <div class="create-card__actions">
          <ion-button fill="clear" (click)="cancelCreate()">{{ 'common.cancel' | translate }}</ion-button>
          <ion-button (click)="create()" [disabled]="isSaving">{{ 'common.create' | translate }}</ion-button>
        </div>
      </ion-card-content>
    </ion-card>
    }

    <!-- List -->
    @if (isLoading) {
    <div class="center-row"><ion-spinner></ion-spinner></div>
    } @else if (loadError) {
    <div class="center-row">
      <p>{{ 'tokens.list.loadError' | translate }}</p>
      <ion-button fill="outline" size="small" (click)="load()">{{ 'common.retry' | translate }}</ion-button>
    </div>
    } @else if (tokens.length === 0) {
    <div class="center-row"><p>{{ 'tokens.list.empty' | translate }}</p></div>
    } @else {
    @for (token of tokens; track token.id) {
    <ion-card class="token-card" [class.token-card--revoked]="isRevoked(token)">
      <ion-card-content>
        <div class="token-card__head">
          <div>
            <a [routerLink]="['/tokens', token.id]"><strong>{{ token.name }}</strong></a>
            <code class="token-card__prefix">{{ token.tokenPrefix }}…</code>
          </div>
          @if (isRevoked(token)) {
          <ion-badge color="medium">{{ 'tokens.card.revokedBadge' | translate }}</ion-badge>
          } @else if (isExpired(token)) {
          <ion-badge color="warning">{{ 'tokens.card.expiredBadge' | translate }}</ion-badge>
          } @else {
          <ion-button size="small" fill="clear" color="danger" (click)="revoke(token)">
            <ion-icon name="trash-outline" slot="start"></ion-icon>
            {{ 'tokens.card.revokeAction' | translate }}
          </ion-button>
          }
        </div>

        <div class="token-card__scopes">
          @for (scope of token.scopes; track scope.feature) {
          <ion-badge [color]="levelColor(scope.level)">{{ scope.feature }}: {{ scope.level }}</ion-badge>
          }
        </div>

        <div class="token-card__meta">
          <span>{{ 'tokens.card.created' | translate:{ date: (token.createdAt | date:'short') } }}</span>
          <span>{{ 'tokens.card.lastUsed' | translate:{ date: token.lastUsedAt ? (token.lastUsedAt | date:'short') : ('tokens.card.never' | translate) } }}</span>
          @if (token.expiresAt) {
          <span>{{ 'tokens.card.expiresAt' | translate:{ date: (token.expiresAt | date:'short') } }}</span>
          }
        </div>
      </ion-card-content>
    </ion-card>
    }
    }
  </div>
</ion-content>
